import React, { useEffect } from 'react';

import { useConfirmPassword } from '../../model/telegramPersonal/useConfirmPassword';
import { TConfirmPasswordFormData } from '../../model/types';

import { EnterPasswordTgPersonalForm } from './EnterPasswordTgPersonalForm';
import { useTelegramAuth } from './TelegramAuthContext';

interface ITelegramPersonalCloudPassword {
  channelId: string;
  onSuccess?: () => void;
}
export const TelegramPersonalCloudPassword = ({
  channelId,
  onSuccess,
}: ITelegramPersonalCloudPassword) => {
  const { confirmPassword, ...mutation } = useConfirmPassword();
  const { setIsLoading } = useTelegramAuth();

  useEffect(() => {
    setIsLoading(mutation.isPending);
  }, [mutation.isPending, setIsLoading]);

  const handleSubmit = async (data: TConfirmPasswordFormData) => {
    if (channelId) {
      await confirmPassword({ channelId, password: data.password }, () => {
        onSuccess?.();
      });
    }
  };

  return (
    <EnterPasswordTgPersonalForm onSubmit={handleSubmit} mutation={mutation} />
  );
};
